var _path, _circle, _path2, _circle2, _path3, _path4, _path5, _rect, _rect2, _rect3, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.98 140.687C80.039 159.414 88.748 205.279 96.6103 230.993C96.9533 232.115 95.4815 232.797 94.8935 231.782C78.3635 203.254 82.8737 181.744 77.624 167.045C71.9765 151.232 21.9989 151.485 28.0097 131.401C35.6992 105.708 76.7901 156.552 81.6479 145.466C88.3472 130.178 56.8418 135.18 30.8635 99.6013C4.88514 64.0223 54.5776 64.9823 69.0957 111.885C78.4383 142.068 84.4717 118.098 81.6479 94.3782C78.8242 70.6588 47.9929 33.1565 69.0957 23.2201C97.863 9.67478 86.6028 104.544 89.4266 106.803C92.2503 109.062 99.0268 83.0834 102.98 41.8569C105.782 12.6349 124.281 21.516 123.717 51.4475C123.152 81.3791 89.4266 123.315 93.354 133.39C95.1451 137.985 97.9486 113.17 116.192 95.7589C133.741 79.0108 133.915 115.434 102.98 140.687Z",
    fill: "#909DF9",
    stroke: "#909DF9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161.698,
    cy: 68.7668,
    r: 12.8308,
    fill: "#223BF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.394 67.1745C155.82 69.1456 161.712 70.7013 163.595 68",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.61,
    cy: 65.2861,
    r: 1.23466,
    transform: "rotate(-9.11976 166.61 65.2861)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.907 105.156C138.412 111.608 146.631 109.089 170.504 105.917L159.078 84.5271C159.078 84.5271 149.741 94.319 135.667 91.2459C121.593 88.1729 121.993 74.3297 120.369 69.4368C120.106 68.9813 119.955 68.6982 118.995 68.6982C118.035 68.6982 118.091 69.4368 118.091 69.4368C118.091 69.4368 117.432 68.9053 116.773 69.0371C116.115 69.1689 115.926 69.8485 115.926 69.8485L115.286 69.6019C114.665 69.4368 113.639 70.0578 113.328 71.1458C113.328 71.1458 107.402 98.7042 122.907 105.156Z",
    fill: "#223BF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.016 59.0998C166.346 58.0947 165.503 56.3645 163.289 56.052C166.64 55.274 169.452 56.8177 169.93 57.9664C170.409 59.1152 169.93 61.5647 167.854 61.9717C167.834 61.5529 167.686 60.105 167.016 59.0998Z",
    fill: "#1CDBCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.558 119.314C179.752 97.7135 175.892 84.6368 167.588 81.1352C165.202 82.8979 160.786 82.9645 158.552 82.2264C158.552 82.2264 154.059 106.517 143.609 129.64C133.16 152.763 122.727 166.361 106.794 175.815C90.8621 185.269 55.1361 194.767 54.3972 192.614C53.1022 188.842 50.8353 186.794 48.0727 189.501C46.9724 190.58 52.8 206.659 56.1266 215.238C70.1915 213.487 102.873 208.2 121.082 201.057C139.29 193.913 160.87 179.261 165.202 170.756C165.202 175.148 165.72 185.667 174.657 197.523C184.535 210.627 210.926 215.799 216.062 218.017C214.953 219.942 212.781 224.904 213.762 227.845C214.742 230.786 226.659 221.717 232.164 213.662C229.304 210.044 199.542 192.478 192.85 180.047C185.493 166.38 183.688 144.791 181.609 119.923L181.558 119.314Z",
    fill: "#223BF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134.779,
    y: 36.0762,
    width: 29.9056,
    height: 133.527,
    transform: "rotate(25.3128 134.779 36.0762)",
    fill: "#FFFDF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151.477,
    y: 43.9736,
    width: 11.4339,
    height: 133.527,
    transform: "rotate(25.3128 151.477 43.9736)",
    fill: "#FFF1CD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140.079,
    y: 38.6104,
    width: 11.4339,
    height: 133.527,
    transform: "rotate(25.3128 140.079 38.6104)",
    fill: "#FFF8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.736 122.716C130.241 130.794 153.567 129.057 177.341 113.868L170.496 98.1748C170.496 98.1748 139.017 112.031 126.351 107.691C113.684 103.35 114.264 90.3215 112.64 84.1953C112.066 83.4686 111.454 83.6885 111.072 84.5345C110.862 83.8729 110.881 83.5449 109.982 83.5449C109.083 83.5449 108.854 84.1953 108.854 84.5345C108.701 84.0232 108.395 83.8128 107.649 83.8128C106.903 83.8128 106.516 84.6609 106.516 84.6609C105.994 84.3481 104.889 84.2523 104.638 86.3714C104.638 86.3714 99.2316 114.638 114.736 122.716Z",
    fill: "#223BF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.413 168.078L77.9529 156.24C76.2284 160.371 74.384 166.394 77.091 170.411C78.8865 173.075 83.0432 177.505 91.932 178.933C99.6107 180.165 104.042 171.471 105.413 168.078Z",
    fill: "#FFDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.029 17.9805L134.728 36.139C134.461 38.9291 132.403 45.2671 134.727 47.8748C136.786 50.185 141.339 46.8757 144.09 44.3531C144.129 45.6144 144.389 48.825 145.122 51.577C145.856 54.3289 149.097 50.4303 150.626 48.137C151.161 49.3219 152.621 52.242 154.181 54.4436C155.74 56.6451 159.626 51.9481 161.537 49.2344L160.029 17.9805Z",
    fill: "#FFDDDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.274 17.6118L152.791 23.1648C152.791 23.1648 153.428 24.9171 155.817 25.7932C158.207 26.6693 160.466 25.793 160.466 25.793L160.274 17.6118Z",
    fill: "#775A0F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.672 105.633C144.918 107.695 141.364 108.05 133.494 108.506L134.252 107.103C147.331 105.524 148.747 104.833 153.165 103.002L151.672 105.633Z",
    fill: "#EEF0FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIllustration);
export default __webpack_public_path__ + "static/media/pencil-illustration.8cf5dc09081e1832efc25639e69c5728.svg";
export { ForwardRef as ReactComponent };